document.addEventListener('DOMContentLoaded', function() {
  const initCarousel = () => {
    const sliders = document.querySelectorAll('.collection-slider');

    sliders.forEach(slider => {
      const container = slider.closest('.collection-grid-container');
      const prevBtn = container.querySelector('.prev-btn');
      const nextBtn = container.querySelector('.next-btn');
      
      if (!slider || !nextBtn || !prevBtn) return;

      const isScrollable = () => slider.scrollWidth > slider.clientWidth;

      let isDown = false;
      let startX;
      let scrollLeft;

      slider.addEventListener('mousedown', (e) => {
        if (!isScrollable()) return;
        isDown = true;
        slider.style.scrollBehavior = 'auto';
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener('mouseleave', () => isDown = false);
      slider.addEventListener('mouseup', () => isDown = false);
      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
      });

      const updateArrows = () => {
        if (!isScrollable()) {
          prevBtn.classList.remove('visible');
          nextBtn.classList.remove('visible');
          return;
        }
        slider.scrollLeft > 10 ? prevBtn.classList.add('visible') : prevBtn.classList.remove('visible');
        nextBtn.classList.add('visible');
      };

      const scrollByStep = (direction) => {
        slider.style.scrollBehavior = 'smooth';
        const item = slider.querySelector('.collection-item');
        const gap = parseInt(window.getComputedStyle(slider).gap) || 0;
        const step = item.clientWidth + gap;
        
        if (direction === 'next') {
          if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 15) {
            slider.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            slider.scrollBy({ left: step, behavior: 'smooth' });
          }
        } else {
          slider.scrollBy({ left: -step, behavior: 'smooth' });
        }
      };

      nextBtn.addEventListener('click', () => scrollByStep('next'));
      prevBtn.addEventListener('click', () => scrollByStep('prev'));
      slider.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);
      setTimeout(updateArrows, 200);
    });
  };

  initCarousel();
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initCarousel);
  }
});